import logo from 'assets/integrations/gitlab/logo.svg';

export default {
  slug: 'gitlab',
  name: 'GitLab (for Optera.io app)',
  summary: 'See merge requests, branches, commits and pipelines jobs informations on Optera.io backlog items.',
  logo: logo
};
